import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { SubledgerContainerModel } from '../../../../../../models/aggregates/erp/subledger/';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';





@Injectable({
  providedIn: 'root'
})
export class SubledgerService extends BaseApiTemplateService<SubledgerContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'subledgers';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'subledgers';
    this.httpClient = http;
  }

  public createSubledgerForAllChartGuid(guid: string, visa: ApiVisa): Observable<ApiResponseModel<SubledgerContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path+'/backoffice-ep/ledger-hdr';
    }
    return this.httpClient.get<ApiResponseModel<SubledgerContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
